// import router from "@/routers/index";
// import { LOGIN_URL } from "@/config";
// import { RouteRecordRaw } from "vue-router";
// import { ElNotification } from "element-plus";
import { useUserStore } from "@/stores/modules/user";
import { useAuthStore } from "@/stores/modules/auth";
// import { redirectUrl } from "@/utils";

// 引入 views 文件夹下所有 vue 文件
// const modules = import.meta.glob("@/views/**/*.vue");
/**
 * @description 初始化动态路由
 */
export const initDynamicRouter = async () => {
  const userStore = useUserStore();
  const authStore = useAuthStore();

  try {
    // 1.获取菜单列表 && 按钮权限列表
    await userStore.getUserInfo();

    //2.获取站内信消息数量

    //3.获取站内信消息列表
  } catch (error) {
    // 当按钮 || 菜单请求出错时，重定向到sso登录页
    authStore.setToken("");
    // redirectUrl();
    // router.replace(LOGIN_URL);
    return Promise.reject(error);
  }
};
